import { TaxData } from '../../data-types/taxes/taxesInterfaces';
import { store } from '../../state/store';
import { roundFloatNumberDecimalsDown } from '../calculations';
import { getNetStake } from './stake-taxes';
import { getWithholdingTax } from './withholding-taxes';

const getFinalPayoutWithoutStakeForPendingBet = (taxData: TaxData) => {
  const { odds } = taxData;
  const netStake = getNetStake(taxData, false);
  const withholdingTax = getWithholdingTax(taxData);

  return odds * netStake - withholdingTax;
};

const getFinalPayoutWithoutStakeForEWPendingBet = (taxData: TaxData, placeOdds: number) => {
  const { odds } = taxData;
  const netStake = getNetStake(taxData, false);
  const withholdingTax = getWithholdingTax(taxData);
  const firstEWPayout = odds * netStake;
  const secondEWPayout = placeOdds * netStake;

  return firstEWPayout + secondEWPayout - withholdingTax;
};

const getFinalPayoutWithStakeForPendingBet = (taxData: TaxData, tax: number) => {
  const { stake, odds } = taxData;
  const rawPayout = odds * stake;

  return rawPayout - rawPayout * (tax / 100);
};

const getFinalPayoutWithStakeForEWPendingBet = (taxData: TaxData, tax: number, placeOdds: number) => {
  const { stake, odds } = taxData;
  const firstEWPayout = odds * stake;
  const secondEWPayout = placeOdds * stake;
  const payout = firstEWPayout + secondEWPayout;

  return payout - payout * (tax / 100);
};

const getFinalPayoutWithStake = (taxData: TaxData, tax: number) => {
  const { placeOdds } = taxData;

  if (placeOdds) {
    return getFinalPayoutWithStakeForEWPendingBet(taxData, tax, placeOdds);
  }

  return getFinalPayoutWithStakeForPendingBet(taxData, tax);
};

const getFinalPayoutWithoutStake = (taxData: TaxData) => {
  const { placeOdds } = taxData;

  if (placeOdds) {
    return getFinalPayoutWithoutStakeForEWPendingBet(taxData, placeOdds);
  }

  return getFinalPayoutWithoutStakeForPendingBet(taxData);
};

export const getFinalPayout = (taxData: TaxData) => {
  const {
    customization: { internationalSettings },
  } = store.getState();
  const { countrySettingsByLocation } = internationalSettings;
  const { payout } = taxData;
  let finalPayout = payout;

  if (countrySettingsByLocation && countrySettingsByLocation.taxRateTicketPayoutWithStake > 0) {
    finalPayout = getFinalPayoutWithStake(taxData, countrySettingsByLocation.taxRateTicketPayoutWithStake);
  }

  if (countrySettingsByLocation && countrySettingsByLocation.taxRateTicketPayoutWithoutStake > 0) {
    finalPayout = getFinalPayoutWithoutStake(taxData);
  }

  return roundFloatNumberDecimalsDown(finalPayout);
};
